import { ButtonProps, IconButton, Tooltip } from '@mui/material';

interface ButtonWithTooltipProps {
  icon: JSX.Element;
  tooltip?: string;
}

const ButtonWithTooltip: React.FC<
  ButtonWithTooltipProps & ButtonProps
> = props => {
  return (
    <Tooltip title={props.tooltip}>
      <span>
        <IconButton
          disabled={props.disabled}
          size="small"
          color="primary"
          onClick={props.onClick}
          {...props}
        >
          {props.icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ButtonWithTooltip;
